













































































































































import {Component, Prop, PropSync, Vue, Watch} from 'vue-property-decorator';
import { DxValidationGroup } from 'devextreme-vue';

import DButton from '@/components/DButton/button.vue';
import DTextbox from '@/components/DTextbox/textbox.vue';
import _ from 'lodash';
import DxPopup from 'devextreme-vue/popup';
import TableGrid from "@/components/TableGrid/grid.vue";
import AuthService from "@/services/auth_service";
import ShareService from "@/services/share-service";
import AcceptService from "@/services/accept-service";
import ElementTabs from "@/components/ElTabs/tabs.vue";
import TreeDropDownBox from '@/components/TreeDropDownBox/tree-drop-down-box.vue';
import DxSelectBox from "devextreme-vue/select-box";
import {DxCheckBox} from "devextreme-vue/check-box";
import YearService from "@/services/years-service";
import dicts_cache_service, {FillBlocksRespKey, Item} from "@/services/dicts_cache_service";
import DxTagBox from "devextreme-vue/tag-box";
import {
  AcceptAggListSchema,
  AcceptChangeSchema,
  AcceptData,
  AcceptDataBackend, CutType,
  EcoFilialSelectionType, EcoNodeFacilitiesTreeItem, EcoNodeSelectionType
} from "@/services/models-service";
import DictCacheService from "@/services/dicts_cache_service";
import {FillBlockShowResponseItem, FillBlocksShowCheckValues} from "@/services/fill-blocks-service";
import DxScrollView from "devextreme-vue/scroll-view";
import AcceptTable from "./accept-table.vue";
import NotifyService from '@/services/notify_service'
import {confirm} from "devextreme/ui/dialog";
import ArrayStore from 'devextreme/data/array_store';
import AcceptTableCustom from "@/views/accept/components/accept-table-custom.vue";
import UserAccessService from '@/services/user_access_service';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import {months, months_list} from "@/constants";
import EcoObjectsService from "@/services/eco-objects-service";

@Component({
  name: 'AcceptBlock',
  components: {
    AcceptTableCustom,
    DxPopup,
    DxValidationGroup,
    DTextbox,
    DButton,
    TableGrid,
    ElementTabs,
    DxSelectBox,
    DxCheckBox,
    DxTagBox,
    DxScrollView,
    AcceptTable,
    DxLoadPanel,
    TreeDropDownBox,
  }
})

export default class extends Vue {
  @PropSync('extAccept') public accept!: AcceptData;
  @PropSync('extEcoTree') public selectionData!: EcoFilialSelectionType[];
  @PropSync('extSelection') public selectedFacilitiesId: number[];
  @Prop() public cut_ds!: any[];

  public service = AcceptService;
  public shareService = ShareService;

  public year_ds = YearService.filteredYearList;

  public period_ds = months_list;
  public periods: string[] = [];
  public selected_months: any = [];

  public permissions: any = {};

  public columns: any[] = [];
  public loading: boolean = false;

  public acceptDS: any = {};
  public backendAcceptList: AcceptAggListSchema;

  public table_block_style: any = {
    width: '1000px',
    height: '500px',
  }
  public tableDrawReady: boolean = false;
  public stopMonthsWatch: boolean = false;

  public ecoService = EcoObjectsService;
  private selectAllNodes = false;
  private currentEcoVersion: number | null = null;

  created() {
    this.service.changed = false;
    this.initColumns();
  }

  mounted() {
    this.tableDrawReady = false;

    this.detectEcoVersion(this.accept.id_cut);

    setTimeout(()=> {
      let box = document.querySelector('.accept-content');
      let width = box?.clientWidth || 1000;
      let height = box?.clientHeight || 500;

      this.table_block_style.width = `${width - 20}px`;
      this.table_block_style.height = `${height - 130}px`;
      this.tableDrawReady = true;
    }, 300);

  }

  @Watch('accept.id_year')
  async watchYear(y1: any, y2: any) {

    this.service.filters_changed = true;
    this.accept.id_cut = null;
    this.accept.months = [];

    this.selectionData = [];
    this.selectedFacilitiesId = [];
    this.resetChanges();
  }

  @Watch('accept.id_cut')
  onCutChange(cutId: string | null) {
    this.detectEcoVersion(cutId);

    this.selectionData = [];
    this.selectedFacilitiesId = [];
  }

  detectEcoVersion(cutId: string | null) {
    if (cutId) {
      const currentCut = this.relative_cut.find(cut => cut.id === cutId);
      if (currentCut?.id_eco_version) {
        if (currentCut.id_eco_version !== this.currentEcoVersion) {
          this.currentEcoVersion = currentCut.id_eco_version;
        } else {
          //
        }

      } else {
        this.currentEcoVersion = null;
      }
    } else {
      this.currentEcoVersion = null;
    }
  }

  // Заполнить данные для дерева выбра объектов теловых узлов
  private updateEcoObjectsTree() {
    this.selectedFacilitiesId = [];
    this.selectionData = [];

    if (this.currentEcoVersion && this.accept.months.length && this.accept.id_year) {

      const yearItem = this.year_ds.find(y => this.accept.id_year === y.id);
      if (yearItem) {
        this.ecoService.get_facilities_tree(this.currentEcoVersion, yearItem.name, this.accept.months.map((m): number => m[0])).then(resp => {
          const selectionDataLocal: EcoFilialSelectionType[] = [];
          if (resp) {
            for (const [filialId, filialItem] of Object.entries(resp)) {
              const fId = Number(filialId);
              const s: EcoFilialSelectionType = {
                id: Number(filialId),
                check: false,
                name: resp[fId].name,
                nodes: Object.keys(filialItem.nodes).map((nodeId): EcoNodeSelectionType => {
                  return {
                    id: Number(nodeId),
                    check: false,
                    name: filialItem.nodes[nodeId].name as string,
                    facilities: filialItem.nodes[nodeId].objects.objects.map((f: EcoNodeFacilitiesTreeItem) => {
                      const check = this.selectedFacilitiesId.includes(f.id);
                      return { id: f.id, name: f.name, check };
                    }),
                  };
                }),
              }
              selectionDataLocal.push(s);
            }
          }
          this.selectionData = selectionDataLocal;
        });

      }
    }
  }

  filterChanging(e: any) {
    if (this.service.changed) {
      confirm(`Текущие изменения будут потеряны. Выполнить сброс изменений?`, 'Сброс изменений')
        .then(async (answer: boolean) => {
          if (!answer) {
            e.component.close();
          } else {
            this.resetChanges();
            this.service.filters_changed = true
          }
        });
    }
  }

  resetChanges() {
    this.acceptDS = {};
    this.service.changed = false;
    this.service.changes = {};
  }

  @Watch('accept.id_cut')
  async watchCut() {

    this.service.filters_changed = true;
    this.accept.months = [];
    this.resetChanges();
  }

  @Watch('accept.months', {deep: true})
  async watchMonths(e1: any, e2: any) {
    if (this.stopMonthsWatch) {
      this.stopMonthsWatch = false;
      return
    }

    this.updateEcoObjectsTree();

    if (this.service.changed) {
      confirm(`Текущие изменения будут потеряны. Выполнить сброс изменений?`, 'Сброс изменений')
        .then(async (answer: boolean) => {
          if (!answer) {
            this.stopMonthsWatch = true;
            this.accept.months = e2;

          } else {
            this.service.filters_changed = true;
            this.resetChanges();
          }
        });
    } else {
      this.service.filters_changed = true;
      this.resetChanges();
    }
  }

  get readyForLoad() {
    return this.accept.id_year && this.accept.id_cut && this.accept.months.length && this.service.filters_changed && this.selectedFacilitiesId.length > 0;
  }

  async loadAccepts() {

    this.permissions = UserAccessService.checkAccept();

    if (this.service.changed) {
      confirm(`Текущие изменения будут потеряны. Вы уверены что хотите загрузить акцепты с потерей изменений?`, 'Загрузка акцептов')
        .then(async (answer: boolean) => {
          if (!answer) {
            return
          }

          await this.load();
        });
    } else {
      await this.load();
    }


  }

   public async load() {
    this.loading = true;
    this.acceptDS = {};
    try {

      this.selected_months = new Set();

      for (let i of this.accept.months) {
        for (let j of i) {
          this.selected_months = this.selected_months.add(j)
        }
      }

      let a = this.selectedFacilitiesId;

      this.selected_months = Array.from(this.selected_months);
      const resp: any = await this.service.getAccepts(this.accept.id_cut, this.selected_months, this.selectedFacilitiesId);

      if (resp) {
        this.backendAcceptList = resp;
        this.acceptDS = this.backendAcceptList.data;


      }
    } catch (e) {
      console.error(e);
    }

    this.service.changed = false;
     this.service.filters_changed = false;
    this.loading = false;
  }

  async onSaving(e: any) {

    if (Object.keys(this.service.changes)?.length) {

      this.loading = true;
      try {

        const payload = new AcceptChangeSchema();
        payload.request_uuid = this.backendAcceptList.request_uuid;
        payload.months = this.selected_months;
        payload.data = this.service.changes;

        const resp: any = await this.service.save(this.accept.id_cut, payload);
        if (resp) {
          this.resetChanges();
          NotifyService.success('Акцепт успешно применен')
          this.service.state.acceptChanges = true;
        } else {
          throw new Error('')
        }


      } catch (e) {
        NotifyService.error(`Ошибка сохранения акцепта: ${e}`);

      }

      this.loading = false;
      // для возможности повторной загрузки без изменения фильтров
      this.service.filters_changed = true;
    }
  }

  private initColumns() {
    this.columns = [
      {
      dataField: "id_object",
      dataType: "string",
      visible: false,
    },
      {
        dataField: "filial",
        caption: "Филиал",
        groupIndex: 0,
        visible: false
      },
      {
        dataField: "heat_node",
        caption: "Тепловой узел",
        groupIndex: 1,
        visible: false
      },
      {
        dataField: "object_name",
        dataType: "string",
        caption: "Объект",
        fixed: 'left',
      },
      {
        caption: "ОК/ХН/Потери",
        columns: this.calcColumn(DictCacheService.ok_hn_blocks, 'ok_hn')
      },
      {
        caption: "Покупка",
        columns: this.calcColumnFixed('sale')
      },
      {
        caption: "Реализация",
        columns: this.calcColumnFixed('purchase')
      },
      {
        caption: "Транспорт, затраты",
        columns: this.calcColumnFixed('transport_costs')
      },
      {
        caption: "Транспорт, выручка",
        columns: this.calcColumnFixed('transport_income')
      },
      {
        caption: "ФБ-02",
        columns: [
          {
            dataField: `blocks.blocks__fb02__tp`,
            caption: 'Тех.потери',
            dataType: 'boolean',
            visible: true,
            allowFiltering: false,
            allowSearch: false,
            allowSorting: false,

          },
          {
            dataField: `blocks.blocks__fb02__kp`,
            caption: 'Ком.потери',
            dataType: 'boolean',
            visible: true,
            allowFiltering: false,
            allowSearch: false,
            allowSorting: false,

          },
          {
            dataField: `blocks.blocks__fb02__tso_p`,
            caption: 'Потери в смежных ТСО',
            dataType: 'boolean',
            visible: true,
            allowFiltering: false,
            allowSearch: false,
            allowSorting: false,

          },
          {
            dataField: `blocks.blocks__fb02__usefull`,
            caption: 'Полезный отпуск',
            dataType: 'boolean',
            visible: true,
            allowFiltering: false,
            allowSearch: false,
            allowSorting: false,

          },
        ]
      }
    ];
  }

  private calcColumn(items: Item[], prefix: string) {
    return items.map((item): any => {
      return {
        dataField: `blocks.blocks__${prefix}__${item.name}`,
        caption: item.display,
        visible: true,
        dataType: 'number',
        format: 'number',
        allowFiltering: false,
        allowSearch: false,
        allowSorting: false,
        editCellTemplate: 'cellTemplate2'
      }
    })
  }

  private calcColumnFixed(prefix: string) {
    const items: any = {volume: 'Объем', tariff: 'Тариф'}
    return Object.keys(items).map((key_): any => {
      return {
        dataField: `blocks.blocks__${prefix}__${key_}`,
        caption: items[key_],
        visible: true,
        dataType: 'number',
        format: key_ === 'tariff' ? 'currency' : 'number',
        allowFiltering: false,
        allowSearch: false,
        allowSorting: false,
        editCellTemplate: 'cellTemplate2'
      }
    })
  }


  get relative_cut(): CutType[] {
    let list = [];
    if (this.accept.id_year) {
      list = this.cut_ds.filter((c:any) => c.id_year === this.accept.id_year && (c.visible_for === 'Видимый для администратора' || c.visible_for === 'Видимый для всех'));
    }
    return list;
  }

  onClose() {
    this.shareService.closeAcceptPopup();
  }

  private onSelectionChanged({ filials, nodes, facilities }: {
    filials: number[];
    nodes: number[];
    facilities: number[];
  }) {
    // Получить обновленный список выбранных id объектов ТУ
    this.selectedFacilitiesId = facilities;
    console.log('selectedFacilitiesId', this.selectedFacilitiesId);
    this.service.filters_changed = true;
  }

  async onOk(e: any) {
    this.onSaving(e);
  }

  async updateTableData(data: any[]) {

    const grid = (this.$refs.accept_grid as any);
    if (grid) {
      grid.loadNewStore(data);
    }
  }
  
  onContentReady(e: any) {
    const dsItems = e.component.getDataSource().items(); 
    const listElement = e.element.querySelector('.dx-list');
    if (!listElement) return;

    if ((listElement as any).__rightClickAttached) return;
    (listElement as any).__rightClickAttached = true;

    const listItems = Array.from(listElement.querySelectorAll('.dx-item.dx-list-item'));

    const handler = (ev: Event) => {
      const target = ev.target as HTMLElement;
      const checkboxArea = target.closest('.dx-list-select-checkbox, .dx-list-item-before-bag, .dx-list-select-checkbox-container, .dx-widget.dx-checkbox');
      if (!checkboxArea) return;

      ev.preventDefault();
      ev.stopPropagation();

      const rowEl = target.closest('.dx-item.dx-list-item') as HTMLElement | null;
      if (!rowEl) return;

      const idx = listItems.indexOf(rowEl);
      if (idx === -1 || idx >= dsItems.length) return;

      const itemData = dsItems[idx];
      (this as any).onMonthRightClick(itemData);
  };

  listElement.addEventListener('contextmenu', handler, true);
}


onMonthRightClick(itemData: any) {
  const allMonths = this.period_ds;

  const itemIndex = allMonths.findIndex(
    (it: any) => Array.isArray(it.months) && Array.isArray(itemData.months)
      ? it.months[0] === itemData.months[0]
      : (it.months === itemData.months)
  );
  if (itemIndex === -1) return;

  const monthsToToggleObjs = allMonths.slice(itemIndex); // объекты {name, months}
  const monthsToToggleRefs = monthsToToggleObjs.map((m: any) => m.months); // ссылки на те же массивы, что в period_ds

  const current = (this.accept.months || []).slice(); // копия
  const selectedNums = current.map((mi: any) => Array.isArray(mi) ? mi[0] : mi);
  const monthsToToggleNums = monthsToToggleRefs.map((r: any) => Array.isArray(r) ? r[0] : r);
  const allSelected = monthsToToggleNums.every((n: number) => selectedNums.includes(n));

  let newSelectedNums = selectedNums.slice();

  if (allSelected) {
    newSelectedNums = newSelectedNums.filter((n: number) => !monthsToToggleNums.includes(n));
  } else {
    monthsToToggleNums.forEach((n: number) => {
      if (!newSelectedNums.includes(n)) newSelectedNums.push(n);
    });
  }

  const newSelectionRefs: any[] = [];

  for (const p of allMonths) {
    const num = Array.isArray(p.months) ? p.months[0] : p.months;
    if (newSelectedNums.includes(num)) {
      newSelectionRefs.push(p.months);
    }
  }

  const uniqSorted = Array.from(new Map(newSelectionRefs.map((r: any) => [Array.isArray(r) ? r[0] : r, r])).values());

  this.accept.months = uniqSorted;
}


  empty() {
    //
  }

}
